import React, { useState, useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import ConfirmExitModal from '../../../components/ConfirmExitModal/ConfirmExitModal';
import { fetchGroupById, updateGroup } from '../../../store/actions/groupsActions'; // CRIE ESTAS ACTIONS
import { fetchUsers } from '../../../store/actions/usersActions'; // NECESSÁRIO PARA READERS
import { fetchDashboards } from '../../../store/actions/dashsActions'; // NECESSÁRIO PARA DASHBOARDS DO GRUPO
import TitlePage from '../../../components/general/TitlePage/TitlePage';
import Input from '../../../components/general/Input/Input';
import TitleSectionComponent from '../../../components/intern/TitleSectionComponent/TitleSectionComponent';
import TableUserForm from '../../../components/intern/TableInform/TableUserForm'; // CRIE ESTE COMPONENTE
import TableDashboardForm from '../../../components/intern/TableInform/TableDashboardForm';
import Button from '../../../components/general/Button/Button';
import AlertComponent from '../../../components/intern/Alert/Alert';
import './UserSearchList.css';

const EditarGrupoPage = () => {
    const [showConfirmExit, setShowConfirmExit] = useState(false);

    const dispatch = useDispatch();
    const { id } = useParams();
    const navigate = useNavigate();

    const [groupName, setGroupName] = useState("");
    const [selectedReaderIds, setSelectedReaderIds] = useState([]);
    const [selectedDashboardIds, setSelectedDashboardIds] = useState([]);
    const [groupNameError, setGroupNameError] = useState("");

    const [readerSearchTerm, setReaderSearchTerm] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedReaderObjects, setSelectedReaderObjects] = useState([]);

    const [dashboardSearchTerm, setDashboardSearchTerm] = useState("");
    const [filteredDashboards, setFilteredDashboards] = useState([]);
    const [selectedDashboardObjects, setSelectedDashboardObjects] = useState([]);

    const [alert, setAlert] = useState(null);
    const alertTimeoutId = useRef(null);
    const [initialData, setInitialData] = useState(null);


    // Correção aqui
    const { groups: allGroups, loading: loadingGroup, error: errorGroup, updateLoading, updateError } = useSelector((state) => state.groups);
    const { users: allUsers, loading: loadingUsers, error: errorUsers } = useSelector(state => state.users);
    const { dashs: allDashboards, loading: loadingDashs, error: errorDashs } = useSelector(state => state.dashs);

    const currentGroup = allGroups.find(group => group.uid === id);

    const showAlert = (type, message) => {
        // Limpa timeout anterior
        if (alertTimeoutId.current) {
            clearTimeout(alertTimeoutId.current);
        }
        setAlert({ type, message });

        alertTimeoutId.current = setTimeout(() => {
            setAlert(null);
            alertTimeoutId.current = null;
        }, 5000);
    };
    useEffect(() => {
        dispatch(fetchUsers());
        dispatch(fetchDashboards());
        if (id) {
            dispatch(fetchGroupById(id));
        }
    }, [dispatch, id]);

    useEffect(() => {
        if (currentGroup && currentGroup.uid === id && allUsers && allDashboards) {
            const validReaderIds = currentGroup.readers?.filter(uid => allUsers.some(u => u.uid === uid)) || [];
            const validDashboardIds = currentGroup.dashboardsId?.filter(id => allDashboards.some(d => d.id === id)) || [];

            setGroupName(currentGroup.groupName || "");
            setSelectedReaderObjects(allUsers.filter(user => validReaderIds.includes(user.uid)));
            setSelectedReaderIds(validReaderIds);
            setSelectedDashboardObjects(allDashboards.filter(dash => validDashboardIds.includes(dash.id)));
            setSelectedDashboardIds(validDashboardIds);

            setInitialData({
                groupName: currentGroup.groupName || "",
                readers: [...validReaderIds].sort(),
                dashboards: [...validDashboardIds].sort(),
            });
        }
    }, [currentGroup, id, allUsers, allDashboards]);



    const handleGroupNameChange = (e) => {
        setGroupName(e.target.value);
        if (e.target.value.length < 3) {
            setGroupNameError("O nome do grupo precisa ter no mínimo 3 caracteres.");
        } else {
            setGroupNameError("");
        }
    };

    const handleReaderSearchChange = (e) => {
        const term = e.target.value;
        setReaderSearchTerm(term);
        if (term.length > 0 && allUsers) {
            setFilteredUsers(
                allUsers.filter(user =>
                    user.userName?.toLowerCase().includes(term.toLowerCase()) ||
                    user.userEmail?.toLowerCase().includes(term.toLowerCase())
                )
            );
        } else {
            setFilteredUsers([]);
        }
    };

    const handleAddReader = (userToAdd) => {
        if (!selectedReaderIds.includes(userToAdd.uid)) {
            setSelectedReaderObjects(prev => [...prev, userToAdd]);
            setSelectedReaderIds(prev => [...prev, userToAdd.uid]);
            setReaderSearchTerm("");
            setFilteredUsers([]);
        } else {
            showAlert('excluir', 'Usuário já está no grupo.');
        }
    };


    const handleRemoveReader = (userIdToRemove) => {
        setSelectedReaderObjects(prev => prev.filter(user => user.uid !== userIdToRemove));
        setSelectedReaderIds(prev => prev.filter(id => id !== userIdToRemove));
        showAlert('excluir', 'Leitor removido.');
    };

    const handleDashboardSearchChange = (e) => {
        const term = e.target.value;
        setDashboardSearchTerm(term);
        if (term.length > 0 && allDashboards) {
            setFilteredDashboards(
                allDashboards.filter(dash =>
                    dash.dashboardName.toLowerCase().includes(term.toLowerCase())
                )
            );
        } else {
            setFilteredDashboards([]);
        }
    };

    const handleAddDashboardToGroup = (dashboardToAdd) => {
        if (!selectedDashboardIds.includes(dashboardToAdd.id)) {
            setSelectedDashboardObjects(prev => [...prev, dashboardToAdd]);
            setSelectedDashboardIds(prev => [...prev, dashboardToAdd.id]);
            setDashboardSearchTerm("");
            setFilteredDashboards([]);
        }
    };

    const handleRemoveDashboardFromGroup = (dashboardIdToRemove) => {
        setSelectedDashboardObjects(prev => prev.filter(dash => dash.id !== dashboardIdToRemove));
        setSelectedDashboardIds(prev => prev.filter(id => id !== dashboardIdToRemove));
        showAlert('excluir', 'Dashboard removido do grupo.');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (groupNameError || !groupName) {
            showAlert('erro', 'Por favor, corrija os erros e preencha os campos obrigatórios.');
            return;
        }

        const groupData = {
            id,
            groupName,
            readers: selectedReaderIds,
            dashboardsId: selectedDashboardIds,
        };

        try {
            await dispatch(updateGroup(groupData)).unwrap();
            showAlert('editar', 'Grupo atualizado com sucesso!');
            navigate("/gerenciar");
        } catch (error) {
            console.error("Erro ao atualizar Grupo:", error);
            showAlert('erro', `Erro ao atualizar grupo: ${error.message || 'Tente novamente.'}`);
        }
    };

    const handleBackClick = () => {
        const hasChanges =
            groupName !== initialData?.groupName ||
            JSON.stringify([...selectedReaderIds].sort()) !== JSON.stringify(initialData?.readers) ||
            JSON.stringify([...selectedDashboardIds].sort()) !== JSON.stringify(initialData?.dashboards);

        if (hasChanges) {
            setShowConfirmExit(true);
        } else {
            navigate("/gerenciar");
        }
    };


    if (loadingGroup || loadingUsers || loadingDashs) return <p>Carregando dados...</p>;
    if (errorGroup || errorUsers || errorDashs) return <p>Erro ao carregar dados: {errorGroup?.message || errorUsers?.message || errorDashs?.message}</p>;
    if (!currentGroup && id) return <p>Grupo não encontrado.</p>;


    return (
        <section className="container-extern content-with-sidebar">
            <FontAwesomeIcon
                icon={faArrowLeft}
                size="lg"
                style={{ cursor: "pointer", marginTop: "8px" }}
                onClick={handleBackClick}
            />

            <TitlePage
                title="Editar Grupo"
                subtitle="Atualize as configurações e permissões do grupo com segurança e eficiência."
            />

            <Helmet>
                <title>Edit Group</title>
            </Helmet>

            <form onSubmit={handleSubmit}>
                <Input
                    type="text"
                    label="Nome do Grupo:"
                    value={groupName}
                    onChange={handleGroupNameChange}
                    placeholder="Digite o nome do grupo"
                    errorMessage={groupNameError}

                />

                <TitleSectionComponent>Leitores associados ao grupo:</TitleSectionComponent>
                <Input
                    type="text"
                    placeholder="Buscar usuário por nome ou e-mail..."
                    value={readerSearchTerm}
                    onChange={handleReaderSearchChange}
                    label="Adicionar Leitor:"
                />

                {filteredUsers.length > 0 && (
                    <ul className="user-search-list common-list-style">
                        {filteredUsers.map((user) => (
                            <li
                                key={user.uid}
                                onClick={() => handleAddReader(user)}
                                className="user-search-item"
                            >
                                {user.userName} ({user.userEmail})
                            </li>
                        ))}
                    </ul>
                )}

                {selectedReaderObjects.length > 0 ? (
                    <TableUserForm
                        dados={selectedReaderObjects}
                        onExcluir={handleRemoveReader}
                    />
                ) : (
                    <p>Nenhum leitor selecionado.</p>
                )}

                <TitleSectionComponent>Dashboards associados no grupo:</TitleSectionComponent>
                <Input
                    type="text"
                    placeholder="Buscar dashboard por nome..."
                    value={dashboardSearchTerm}
                    onChange={handleDashboardSearchChange}
                    label="Adicionar Dashboard ao Grupo:"
                />
                {filteredDashboards.length > 0 && (
                    <ul className="user-search-list common-list-style">
                        {filteredDashboards.map((dash) => (
                            <li key={dash.id} onClick={() => handleAddDashboardToGroup(dash)} className="user-search-item">
                                {dash.dashboardName}
                            </li>
                        ))}
                    </ul>
                )}
                <TableDashboardForm
                    dados={selectedDashboardObjects}
                    tipoContato="Dashboard no Grupo"
                    onExcluir={handleRemoveDashboardFromGroup}
                    exibirAcesso={false}
                    exibirEditar={false}
                />

                <div className="section-btn-page">
                    <Button type="submit" variant="save" className='btn-add' disabled={
                        updateLoading ||
                        !!groupNameError ||
                        !groupName ||
                        !initialData ||
                        (
                            groupName === initialData.groupName &&
                            JSON.stringify([...selectedReaderIds].sort()) === JSON.stringify(initialData.readers) &&
                            JSON.stringify([...selectedDashboardIds].sort()) === JSON.stringify(initialData.dashboards)
                        )
                    }>
                        {updateLoading ? "Salvando..." : "Salvar Grupo"}
                    </Button>
                </div>
                {alert && <AlertComponent type={alert.type} message={alert.message} onClose={() => setAlert(null)} />}
                {updateError && <p className="error-message">Erro ao atualizar grupo: {updateError.message || updateError}</p>}
            </form>

            <ConfirmExitModal
                isOpen={showConfirmExit}
                onConfirm={() => navigate("/gerenciar")} // no Grupo
                onCancel={() => setShowConfirmExit(false)}
            />

        </section>
    );
};

export default EditarGrupoPage;
